import { Capacitor, registerPlugin } from "@capacitor/core";

export interface SopoNavigationBarPlugin {
    hide(): Promise<void>;
}

const SopoNavigationBar = registerPlugin<SopoNavigationBarPlugin>('SopoNavigationBar');

export const initNavigationBar = async () => {
    const platform = Capacitor.getPlatform();
    if (platform !== 'android') return;
    try {
        await SopoNavigationBar.hide();
    } catch (error) {
        console.error(error);
    }
}

export default SopoNavigationBar;